import axios from "axios"

import CisSearchTagService from "@/services/cis-searchtag.service";

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

export default class makeDtSetSearchTag {
    constructor (category, st_dt, en_dt) {
        this.sel_category = category
        this.st_dt = st_dt
        this.en_dt = en_dt

        this.majorClsList = []
        this.brandList = []
    }

    async initialize() {
        await this.getMajorClsList()
    }

    async getMajorClsList() {
        // 선택한 카테고리의 대분류 정보를 획득한다. (데이터 셋 생성 시 대분류 필터 적용 용도)
        const firstClasses = await CisSearchTagService.listFirstClass({
            ctgSq: this.sel_category
        }, source);

        if (firstClasses.data.success)
            this.majorClsList = firstClasses.data.data
    }

    async run() {
        var resDataset = []; 

        var gubunTypes = ['attributes', 'brands']

        for (const type of gubunTypes) {
            // gubun 데이터 획득
            const response = await CisSearchTagService.listGubun({
                startDate : this.st_dt,
                endDate : this.en_dt,
                ctgSq : this.sel_category,
                fclsSq : null,
                brand : null,
                middle : null,
                type : type,
            }, source)

            var gubuns = [];

            if (response && response.status === 200) {
                for(const item of response.data.data)
                    gubuns.push(item.value)
            }

            // tag
            const tagResp = await CisSearchTagService.getBrandPinDataExp({
                startDate : this.st_dt,
                endDate : this.en_dt,
                ctgSq : this.sel_category,
                fclsSq : null,
                brand : null,
                middle : null,
                type : type,
                gubuns : gubuns
            }, source);
            
            if (tagResp && tagResp.status === 200) {
                var brdTags = [];

                for(const item of tagResp.data.data) {
                    brdTags.push({
                        tag: item.sub,
                        freq: item.freq,
                        criteria: item.subTitle
                    });     
                }

                if (type == 'attributes')
                    resDataset.push({'sheet_type': 0, 'sheet_nm': 'TAG 순위 및 검색량(속성)_전체', 'data': brdTags, 'cat': ['검색량', '구분']})
                else 
                    resDataset.push({'sheet_type': 0, 'sheet_nm': 'TAG 순위 및 검색량(브랜드)_전체', 'data': brdTags, 'cat': ['검색량', '구분']})
            }
        }

        if (this.majorClsList.length > 0) {
            for (const major of this.majorClsList) {
                for (const type of gubunTypes) {
                    // gubun 데이터 획득
                    const response = await CisSearchTagService.listGubun({
                        startDate : this.st_dt,
                        endDate : this.en_dt,
                        ctgSq : this.sel_category,
                        fclsSq : major.id,
                        brand : null,
                        middle : null,
                        type : type,
                    }, source)

                    var gubuns = [];

                    if (response && response.status === 200) {
                        for(const item of response.data.data)
                            gubuns.push(item.value)
                    }

                    // tag
                    const tagResp = await CisSearchTagService.getBrandPinDataExp({
                        startDate : this.st_dt,
                        endDate : this.en_dt,
                        ctgSq : this.sel_category,
                        fclsSq : major.id,
                        brand : null,
                        middle : null,
                        type : type,
                        gubuns : gubuns
                    }, source);
                    
                    if (tagResp && tagResp.status === 200) {
                        var brdTags = [];

                        for(const item of tagResp.data.data) {
                            brdTags.push({
                                tag: item.sub,
                                freq: item.freq,
                                criteria: item.subTitle
                            });     
                        }

                        if (type == 'attributes')
                            resDataset.push({'sheet_type': 0, 'sheet_nm': `TAG 순위 및 검색량(속성)_${major.title}`, 'data': brdTags, 'cat': ['검색량', '구분']})
                        else 
                            resDataset.push({'sheet_type': 0, 'sheet_nm': `TAG 순위 및 검색량(브랜드)_${major.title}`, 'data': brdTags, 'cat': ['검색량', '구분']})
                    }
                }
            }
        }

        return resDataset
    }
}